const markerLabels: Record<string, string> = {
  'CD(S)': $localize`:@@details.labels.marker.countdown:カウントダウン`,
  'RSSTSTART': $localize`:@@details.labels.marker.rsstStart:RSST開始`,
  'RSST END': $localize`:@@details.labels.marker.rsstEnd:RSST 終了`,
  'RSSTEND': $localize`:@@details.labels.marker.rsstEnd2:RSST 終了`,
  'ABORT': $localize`:@@details.labels.marker.abort:中止`,
  'S1(S)': $localize`:@@details.labels.marker.s1Start:1mL 開始`,
  'S1(P)': $localize`:@@details.labels.marker.s1Pause:停止`,
  'S1(R)': $localize`:@@details.labels.marker.s1Resume:1mL 再開`,
  'S1(E)': $localize`:@@details.labels.marker.s1End:1mL 終了`,
  'S3(S)': $localize`:@@details.labels.marker.s3Start:3mL 開始`,
  'S3(P)': $localize`:@@details.labels.marker.s3Pause:停止`,
  'S3(R)': $localize`:@@details.labels.marker.s3Resume:3mL 再開`,
  'S3(E)': $localize`:@@details.labels.marker.s3End:3mL 終了`,
  'S5(S)': $localize`:@@details.labels.marker.s5Start:5mL 開始`,
  'S5(P)': $localize`:@@details.labels.marker.s5Pause:停止`,
  'S5(R)': $localize`:@@details.labels.marker.s5Resume:5mL 再開`,
  'S5(E)': $localize`:@@details.labels.marker.s5End:5mL 終了`,
};

const eventTypeLabels: Record<string, string> = {
  swallow: $localize`:@@details.labels.eventType.swallow:嚥下`,
  cough: $localize`:@@details.labels.eventType.cough:せき・むせ`,
  other: $localize`:@@details.labels.eventType.other:嚥下以外`,
};

function normalizeEventType(type: string): keyof typeof eventTypeLabels {
  if (type === 'swallow') return 'swallow';
  if (type === 'cough') return 'cough';
  return 'other';
}

/**
 * MWST / FoodTest 波形マーカーラベルのパターン翻訳。
 * CSV helper が生成する `A{attempt}[D]({state})` 形式を翻訳する。
 *
 * 例: A1(S) → 試行1 開始, A2D(E) → 試行2空嚥下 終了
 */
const attemptStateLabels: Record<string, string> = {
  S: $localize`:@@details.labels.attemptState.start:開始`,
  P: $localize`:@@details.labels.attemptState.pause:停止`,
  R: $localize`:@@details.labels.attemptState.resume:再開`,
  E: $localize`:@@details.labels.attemptState.end:終了`,
};

const attemptPrefix = $localize`:@@details.labels.attemptPrefix:試行`;
const attemptDrySuffix = $localize`:@@details.labels.attemptDry:空嚥下`;

function translateAttemptLabel(label: string): string | null {
  const match = label.match(/^A(\d)(D?)\(([SPRE])\)$/);
  if (!match) return null;
  const attempt = match[1];
  const dry = match[2] === 'D';
  const state = match[3];
  const stateLabel = attemptStateLabels[state];
  if (!stateLabel) return null;

  return `${attemptPrefix}${attempt}${dry ? attemptDrySuffix : ''} ${stateLabel}`;
}

export function translateMarkerLabel(label: string): string {
  if (!label) return label;
  const entry = markerLabels[label];
  if (entry) return entry;
  return translateAttemptLabel(label) ?? label;
}

export function translateEventType(type: string): string {
  if (!type) return type;
  const normalizedType = normalizeEventType(type);
  return eventTypeLabels[normalizedType] ?? type;
}
